const features = [
  {
    step: '01',
    title: '作る',
    description: '伝えたい内容を入力するだけで、AIがLPのたたき台を作成します。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
      </svg>
    ),
  },
  {
    step: '02',
    title: '公開する',
    description: '作成したページをそのまま公開できます。独自ドメインの設定も不要です。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9a9 9 0 01-9-9m9 9c1.657 0 3-4.03 3-9s-1.343-9-3-9m0 18c-1.657 0-3-4.03-3-9s1.343-9 3-9" />
      </svg>
    ),
  },
  {
    step: '03',
    title: '直す',
    description: 'あとから文章や内容をチャットで調整できます。何度でも修正可能です。',
    icon: (
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
      </svg>
    ),
  },
];

export default function Features() {
  return (
    <section id="home-features" className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-6xl mx-auto">
        <div className="max-w-2xl mb-14">
          <span className="section-label">できること</span>
          <h2 className="section-title">
            ChatLPなら、作成から
            <br className="hidden md:block" />
            公開・修正まで進められます
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item) => (
            <article
              key={item.step}
              className="group rounded-lg p-8 bg-white border border-border hover:shadow-md transition-all duration-200"
            >
              <div className="w-12 h-12 rounded-lg bg-surface flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-200">
                {item.icon}
              </div>
              <p className="text-xs text-textMuted font-semibold tracking-widest mb-2">
                {item.step}
              </p>
              <h3 className="text-xl font-bold text-primary mb-3">{item.title}</h3>
              <p className="text-sm text-textMuted leading-relaxed">{item.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
